import { memo } from 'react';

function GoalIcon() {
  return (
    <svg width="92" height="85" viewBox="0 0 92 85" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4275_25676)">
        <path
          d="M43.4365 85C66.8924 85 85.9066 65.9722 85.9066 42.5C85.9066 19.0278 66.8924 0 43.4372 0C19.9819 0 0.967773 19.0278 0.967773 42.5C0.967773 65.9722 19.9819 85 43.4365 85Z"
          fill="#F4F6F8"
        />
        <mask id="mask0_4275_25676" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="86" height="85">
          <path
            d="M43.4365 85C66.8924 85 85.9066 65.9722 85.9066 42.5C85.9066 19.0278 66.8924 0 43.4372 0C19.9819 0 0.967773 19.0278 0.967773 42.5C0.967773 65.9722 19.9819 85 43.4365 85Z"
            fill="#EAEEF9"
          />
        </mask>
        <g mask="url(#mask0_4275_25676)">
          <path
            d="M80.4871 35.3672H8.71578C7.58912 35.3672 6.67578 36.2805 6.67578 37.4072V47.4025C6.67578 48.5292 7.58912 49.4425 8.71578 49.4425H80.4871C81.6137 49.4425 82.5271 48.5292 82.5271 47.4025V37.4072C82.5271 36.2805 81.6137 35.3672 80.4871 35.3672Z"
            fill="#DFE3E8"
            stroke="#919EAB"
            strokeWidth="2"
          />
          <path
            opacity="0.6"
            d="M49.2202 27.3666H0.610431C-0.0185689 27.3666 -0.557129 26.8274 -0.557129 26.1977V22.5114C-0.557129 21.8817 -0.0185689 21.3418 0.610431 21.3418H49.2196C49.8486 21.3418 50.3878 21.8817 50.3878 22.5114V26.1977C50.3878 26.8274 49.8492 27.3666 49.2202 27.3666Z"
            fill="#DFE3E8"
          />
          <path
            opacity="0.6"
            d="M87.3171 27.3666H56.4981C55.8691 27.3666 55.3306 26.8274 55.3306 26.1977V22.5114C55.3306 21.8817 55.8691 21.3418 56.4981 21.3418H87.3171C87.9461 21.3418 88.4846 21.8817 88.4846 22.5114V26.1977C88.4846 26.8274 87.9461 27.3666 87.3171 27.3666Z"
            fill="#DFE3E8"
          />
          <path
            opacity="0.6"
            d="M85.1599 45.5287H142.484C143.113 45.5287 143.652 44.9895 143.652 44.3598V40.6735C143.652 40.0438 143.113 39.5039 142.484 39.5039H85.1599C84.5309 39.5039 83.9917 40.0438 83.9917 40.6735V44.3598C83.9917 44.9895 84.5309 45.5287 85.1599 45.5287Z"
            fill="#DFE3E8"
          />
          <path
            d="M40.5047 45.5287H76.984C77.6123 45.5287 78.1515 44.9895 78.1515 44.3598V40.6735C78.1515 40.0438 77.6123 39.5039 76.984 39.5039H40.5047C39.8757 39.5039 39.3364 40.0438 39.3364 40.6735V44.3598C39.4262 44.9895 39.8757 45.5287 40.5047 45.5287Z"
            fill="#919EAB"
          />
          <path
            d="M11.574 45.5287H32.7784C33.4074 45.5287 33.9467 44.9895 33.9467 44.3598V40.6735C33.9467 40.0438 33.4074 39.5039 32.7784 39.5039H11.574C10.945 39.5039 10.4058 40.0438 10.4058 40.6735V44.3598C10.4058 44.9895 10.8546 45.5287 11.574 45.5287Z"
            fill="#919EAB"
          />
          <path
            opacity="0.6"
            d="M57.9356 57.2175H-1.81467C-2.44367 57.2175 -2.98291 57.7567 -2.98291 58.3864V62.0727C-2.98291 62.7024 -2.44367 63.2416 -1.81467 63.2416H58.0253C58.6543 63.2416 59.1936 62.7024 59.1936 62.0727V58.3864C59.1038 57.7567 58.5646 57.2175 57.9356 57.2175Z"
            fill="#DFE3E8"
          />
          <path
            opacity="0.6"
            d="M57.9356 4.58789H-1.81467C-2.44367 4.58789 -2.98291 5.12713 -2.98291 5.75681V9.44309C-2.98291 10.0728 -2.44367 10.6127 -1.81467 10.6127H58.0253C58.6543 10.6127 59.1936 10.0728 59.1936 9.44309V5.75681C59.1038 5.12713 58.5646 4.58789 57.9356 4.58789Z"
            fill="#DFE3E8"
          />
          <path
            opacity="0.6"
            d="M104.478 57.2175H66.2921C65.6631 57.2175 65.1245 57.7567 65.1245 58.3864V62.0727C65.1245 62.7024 65.6631 63.2416 66.2921 63.2416H104.388C105.017 63.2416 105.557 62.7024 105.557 62.0727V58.3864C105.557 57.7567 105.107 57.2175 104.478 57.2175Z"
            fill="#DFE3E8"
          />
          <path
            opacity="0.6"
            d="M104.478 4.58789H66.2921C65.6631 4.58789 65.1245 5.12713 65.1245 5.75681V9.44309C65.1245 10.0728 65.6631 10.6127 66.2921 10.6127H104.388C105.017 10.6127 105.557 10.0728 105.557 9.44309V5.75681C105.557 5.12713 105.107 4.58789 104.478 4.58789Z"
            fill="#DFE3E8"
          />
          <path
            opacity="0.6"
            d="M55.2401 74.0469H93.4262C94.0552 74.0469 94.5944 74.5861 94.5944 75.2158V78.9021C94.5944 79.5318 94.0552 80.071 93.4262 80.071H55.3299C54.7009 80.071 54.1616 79.5318 54.1616 78.9021V75.2158C54.1616 74.5861 54.6111 74.0469 55.2401 74.0469Z"
            fill="#DFE3E8"
          />
          <path
            opacity="0.6"
            d="M-1.81418 74.0469H47.2437C47.8727 74.0469 48.4113 74.5861 48.4113 75.2158V78.9021C48.4113 79.5318 47.8727 80.071 47.2437 80.071H-1.81418C-2.44318 80.071 -2.98242 79.5318 -2.98242 78.9021V75.2158C-2.98242 74.5861 -2.44318 74.0469 -1.81418 74.0469Z"
            fill="#DFE3E8"
          />
        </g>
        <path
          d="M86.2623 48.1345L70.978 40.4063C70.2266 40.0193 69.2909 40.7177 69.4044 41.5799L72.4413 58.4453C72.5671 59.2361 73.6463 59.4408 74.1026 58.7214L76.4016 55.6804C76.7063 55.2003 77.4162 55.1759 77.7181 55.5818L81.6186 60.8178C81.8607 61.1422 82.2972 61.1952 82.6372 60.9409L85.7414 58.6255C86.0821 58.3712 86.1556 57.9373 85.9135 57.6123L82.0137 52.3777C81.6812 51.9309 81.9368 51.2978 82.4836 51.1428L86.0529 49.8059C86.8294 49.6053 86.9838 48.4799 86.2623 48.1345Z"
          fill="#DFE3E8"
          stroke="#919EAB"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_4275_25676">
          <rect width="90.44" height="85" fill="white" transform="translate(0.780273)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(GoalIcon);
